import { BaseAction, BaseActionResult, ActionType } from '../common';

/**
 * Represents the external link action's type
 */
export const enum ExternalLinkType {
  Website = 'https/http',
  Mail = 'mailto',
  Tel = 'tel',
  SMS = 'sms',
  DeepLink = 'deeplink',
}

/**
 * Represents the external link action.
 */
export type ExternalLinkAction = BaseAction & {
  /** The type of the action. */
  actionType: ActionType.ExternalLink;

  options: {
    /** The url of the action link to. */
    url?: any;
  };

  /** The type of the action link to. */
  type: ExternalLinkType;
};

/**
 * Represents the result of the external link action.
 */
export type ExternalLinkActionResult = BaseActionResult & {
  /** The type of the action. */
  actionType: ActionType.ExternalLink;

  response: {
    /** The url of the external link */
    value: string;
  };
};
